<template>
  <div class="">
    <!--选择省-->
   <!-- <button @click="showAddr('province')">选择省</button>
    <button @click="showAddr('city')">选择市</button>
    <button @click="showAddr('county')">选择区/县</button>
    <button @click="showAddr('village')">选择街道/镇</button>-->
    <transition name="bounce2">
      <section class="area-select-wapper" v-show="provinceVisible" @click="provinceVisible=false;">
        <div class="area-select-innerBox" @click.stop="">
          <h2 class="area-select-title">选择省<i class="mintui mintui-field-error" @click="provinceVisible=false;"></i></h2>
          <div class="area-list-box">
            <ul class="area-list">
              <li class="area-list-item" v-for="item in myAddressProvinceData" @click="getListItem('myAddressCityData',item)">
                <label class="area-item-name">{{item.value}}</label>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </transition>
    <!--选择市-->
    <transition name="bounce2">
      <section class="area-select-wapper" v-show="cityVisible" @click="cityVisible=false;">
        <div class="area-select-innerBox" @click.stop="">
          <h2 class="area-select-title">选择市<i class="mintui mintui-field-error" @click="cityVisible=false;"></i></h2>
          <div class="area-list-box">
            <ul class="area-list">
              <li class="area-list-item" v-for="item in myAddressCityData" @click="getListItem('myAddressCountyData',item)">
                <label class="area-item-name">{{item.value}}</label>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </transition>
    <!--选择区/县-->
    <transition name="bounce2">
      <section class="area-select-wapper" v-show="countyVisible" @click="countyVisible=false;">
        <div class="area-select-innerBox" @click.stop="">
          <h2 class="area-select-title">选择区/县<i class="mintui mintui-field-error" @click="countyVisible=false;"></i></h2>
          <div class="area-list-box">
            <ul class="area-list">
              <li class="area-list-item" v-for="item in myAddressCountyData" @click="getListItem('lastLevel',item)">
                <label class="area-item-name">{{item.value}}</label>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </transition>
    <!--选择镇-->
   <!-- <transition name="bounce2">
      <section class="area-select-wapper" v-show="villageVisible" @click="villageVisible=false;">
        <div class="area-select-innerBox" @click.stop="">
          <h2 class="area-select-title">选择镇/街道<i class="mintui mintui-field-error" @click="villageVisible=false;"></i></h2>
          <div class="area-list-box">
            <ul class="area-list">
              <li class="area-list-item" v-for="item in myAddressVillageData" @click="getListItem('lastLevel',item)">
                <label class="area-item-name">{{item.value}}</label>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </transition>-->
  </div>
</template>

<script>
	export default {
    name: 'editAddr',
    props:{
      curProvince: {
        type: String,
        default: ''
      },
      curCity: {
        type: String,
        default: ''
      },
      curCounty: {
        type: String,
        default: ''
      },
      /*curVillage: {
        type: String,
        default: ''
      },*/
    },
    data () {
      return {
        myAddressProvinceData:[],
        myAddressCityData:[],
        myAddressCountyData:[],
        // myAddressVillageData:[],
        provinceVisible:false,
        cityVisible:false,
        countyVisible:false,
        // villageVisible:false,
        myProvince:'',
        myCity:'',
        myCounty:'',
        // myVillage:'',
      }
    },
    mounted(){
      this.$nextTick(() => { //vue里面全部加载好了再执行的函数  （类似于setTimeout）

      });
    },
    methods: {
      showAddr(type,parent){
        this.myProvince=this.curProvince;
        this.myCity=this.curCity;
        this.myCounty=this.curCounty;
        if(parent){
          if(type=='city'){
            //选择市
            this.getListItem('myAddressCityData',{id:parent});
          }else if(type=='county'){
            //选择县
            this.getListItem('myAddressCountyData',{id:parent});
          }else{
            this.getListItem();
          }
        }else{
          //没有父级id
          this.getListItem();
        }


      },
      getListItem(dataType,item){
        //显示相应的选择项
        if (!dataType) {
          this.provinceVisible = true;
        }else if (dataType == 'myAddressCityData') {
          this.myProvince=item.id;
          if(this.myProvince){
            this.cityVisible = true;
          }else{
            this.provinceVisible = true;
          }
        }else if (dataType == 'myAddressCountyData') {
          this.myCity =item.id;
          if(this.myCity){
            this.countyVisible = true;
          }else if(this.myProvince){
            this.cityVisible = true;
          }else{
            this.provinceVisible = true;
          }
        }else if (dataType == 'lastLevel') {
          this.myCounty=item.id;
          if (this.myCounty) {
            this.provinceVisible = false;
            this.countyVisible = false;
            this.cityVisible = false;
            this.$emit('endSelectAddr',[this.myProvince,this.myCity,this.myCounty])
          } else if (this.myCity) {
            this.countyVisible = true;
          } else if (this.myProvince) {
            this.cityVisible = true;
          } else {
            this.provinceVisible = true;
          }
        }
        //获取城市参数
        if(dataType!='lastLevel'){
          this.$cHttp.post('regions/index',{
            parent:item&&item.id?item.id:'1'
          }).then((res)=>{
            if(res.status&&res.status==1){
              if(dataType){
                this[dataType]=res.data;
              }else{
                this.myAddressProvinceData=res.data;
              }
            }else{
              this.$toast(res.error_msg)
            }

          }).catch((msg)=>{
            this.$toast(msg);
          })
        }

      }
    },
    components:{

    }
  }
</script>
<style>
	.picker-item{
		font-size:10px;
		padding: 0 5px;
	}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
  .area-select-wapper{
    display: flex;
    align-items: center;
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(0,0,0,.7);
    z-index: 100;
    .area-select-innerBox{
      position: relative;
      width: 80%;
      height: 70%;
      margin: 0 auto;
      border-radius: .06rem;
      background-color: #fff;
      .area-select-title{
        padding: 0 .1rem;
        height: .35rem;
        line-height: .35rem;
        color: #333;
        text-align: center;
        border-bottom: 1px solid #ddd;
        .mintui-field-error{
          float: right;
          color: #ff626f;
          font-size: .20rem;
        }
      }
      .area-list-box{
        position:absolute;
        top:.36rem;
        bottom:.1rem;
        left:0;
        right:0;
        overflow: auto;
        .area-list{
          padding-left: .1rem;
          .area-list-item{
            padding-right: .1rem;
            height: .3rem;
            line-height: .3rem;
            font-size: .14rem;
            color: #444;
            border-bottom: 1px solid #eee;
            &:active{
              background-color: #eee;
            }
            .area-item-name{

            }
          }
        }
      }
    }
  }
  .bounce2-enter-active {
    animation: bounce2-in .5s;
  }
  .bounce2-leave-active {
    animation: bounce2-out .5s;
  }
  @keyframes bounce2-in {
    0% {
      transform: scale(.5);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes bounce2-out {
    0% {
     opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/basic/addrSelector/addrSelector.vue